const MINIMUM_VERSIONS: Record<string, number> = {
  chrome: 124,
  edge: 124,
  firefox: 125,
  safari: 16,
}

const UNSUPPORTED_BROWSERS = new Set<string>([])

const SESSION_KEY = "browser_compat_dismissed"

type BrowserInfo = { name: string; version: number }

function detectBrowser(): BrowserInfo | null {
  const ua = navigator.userAgent

  // Order matters: Edge must be checked before Chrome (Edge UA includes "Chrome")
  const edgeMatch = /Edg\/(\d+)/.exec(ua)
  if (edgeMatch) return { name: "edge", version: parseInt(edgeMatch[1], 10) }
  const chromeMatch = /Chrome\/(\d+)/.exec(ua)
  if (chromeMatch) return { name: "chrome", version: parseInt(chromeMatch[1], 10) }
  const firefoxMatch = /Firefox\/(\d+)/.exec(ua)
  if (firefoxMatch) return { name: "firefox", version: parseInt(firefoxMatch[1], 10) }
  const safariMatch = /Version\/(\d+).*Safari/.exec(ua)
  if (safariMatch) return { name: "safari", version: parseInt(safariMatch[1], 10) }

  return null
}

function isSupported(browser: BrowserInfo): boolean {
  if (UNSUPPORTED_BROWSERS.has(browser.name)) return false
  const min = MINIMUM_VERSIONS[browser.name]
  return min === undefined || browser.version >= min
}

function buildBanner(): HTMLElement {
  const div = document.createElement("div")

  div.id = "browser-compat-banner"
  div.setAttribute("role", "alert")
  div.className = "alert alert-warning alert-dismissible fade show mb-0"
  div.style.cssText =
    "border-radius: 0; border-left: none; border-right: none; border-top: none; position: sticky; top: 0; z-index: 1031;"

  div.innerHTML = `
    <strong>Browser Update Recommended</strong>
    You are using an older version of your browser. To ensure all features work correctly, please update to the latest version.
    <button type="button" class="btn-close" aria-label="Close"></button>
  `

  div.querySelector(".btn-close")!.addEventListener("click", () => {
    sessionStorage.setItem(SESSION_KEY, "1")
    div.remove()
  })
  return div
}

// eslint-disable-next-line import/prefer-default-export
export function initBrowserCompatibilityCheck(): void {
  const run = () => {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return

      const browser = detectBrowser()
      if (!browser || isSupported(browser)) return

      const banner = buildBanner()
      document.body.prepend(banner)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("[browserCompatibility] check failed:", e)
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run)
  } else {
    run()
  }
}
